'use client';

import { SiteContainerAlpha } from '@blufin/react';
import type { BaseRuntimeConfig } from '@blufin/web';
import dynamic from 'next/dynamic';

import styles from './page.module.scss';
import { BuiltByBert } from '../components/BuiltByBert';

const Map = dynamic(() => import('../components/Map').then(mod => mod.Map), {
  /** Loading fallback. */
  loading: () => <div className={styles.fallback} />,
  ssr: false
});

const runtimeConfig = JSON.parse(
  process.env['NEXT_PUBLIC_APP_CONFIG'] ??
    '{"environment":"localhost","apiConfig":{"apiUrl":"https://api.shakacams.com","hmacEnabled":false}}'
) as BaseRuntimeConfig;
const version = process.env['NEXT_PUBLIC_APP_VERSION'];

const Home = () => {
  return (
    <SiteContainerAlpha runtimeConfig={runtimeConfig} version={version}>
      <main className={styles.main}>
        <Map />
        <BuiltByBert />
      </main>
    </SiteContainerAlpha>
  );
};

export default Home;
